/**
 * External dependencies
 */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */

import { requestCurrentWebIfNotRequested } from 'state/current-web/actions';
import { getCurrentWeb, requestingCurrentWeb } from 'state/current-web/selectors';
import WebPlanLoader from './web-plan-loader';
import Icon from 'components/icon';
import Money from 'components/money';
import PlanName from 'components/plan-name';
import DateTime from 'components/date-time';
import Coupon from 'components/coupon';
import { Stack, Box, Divider, Text } from '@towersystems/towersystems-design-system';
import DetailListItem from 'components/detail-list-item';
import SubscriptionStatus from 'components/subscription-status';
import Card from 'components/card';


/**
 * Style dependencies
 */
import './styles.scss';

const CurrentWebPlanCard = (props) => {
	let currentWeb = props.currentWeb;

	useEffect(() => {
		props.requestCurrentWeb();
	}, []);
	console.log(currentWeb);

	if (!currentWeb && !props.requesting) {
		return (
			<Card>
				<Card.Header heading='Plan details' />
				<Stack>
					<Card.Section>
						<DetailListItem label='Plan amount' />
					</Card.Section>
					<Card.Section>
						<DetailListItem label='Current billing period' />
					</Card.Section>
					<Card.Section>
						<DetailListItem label='Next billing date' />
					</Card.Section>
				</Stack>
			</Card>
		);
	}

	if (!currentWeb && props.requesting) {
		return <WebPlanLoader />;
	}

	console.log("current webplan: "+JSON.stringify(currentWeb));

	return (
		<Stack space='xxlarge'>
			<Card>
				<Stack>
					<Card.Section>
						<Box display='flex' padding='small' alignItems='center'>
							<Stack space='small'>
								<Box>
									<PlanName value={currentWeb.plan_id} />
								</Box>
								<Box>
									<SubscriptionStatus status={currentWeb.status} />
								</Box>
							</Stack>
						</Box>
					</Card.Section>
					{currentWeb.status == 'future' && (
						<Card.Section>
							<DetailListItem
								label='Subscription start date'
								detail={<DateTime date={currentWeb.start_date} format='Do MMM, YYYY' />}
							/>
						</Card.Section>
					)}

					<Card.Section>
						<DetailListItem
							label='Base price'
							detail={
								<Box>
									<Money value={currentWeb.plan_unit_price / 100} /> /{' '}
									{currentWeb.billing_period} {currentWeb.billing_period_unit}
								</Box>
							}
						/>
					</Card.Section>
					{currentWeb.addons && (
						<Card.Section>
							<Box padding='small'>
								<Box marginBottom='medium'>
									<Text weight='medium' size='small'>
										Addons
									</Text>
								</Box>
								<Stack space='medium' dividers>
									{currentWeb.addons.map(({ unit_price, quantity, amount, id }) => {
										return (
											<Box
												key={id}
												display='flex'
												alignItems='center'
												justifyContent='spaceBetween'
											>
												<Text size='small'>{id}</Text>
												<Text size='small'>
													<Money value={amount / 100} />
													<span>(x{quantity})</span>
												</Text>
											</Box>
										);
									})}
								</Stack>
							</Box>
						</Card.Section>
					)}
					{currentWeb.coupons && (
						<Card.Section>
							<Box padding='small'>
								<Box marginBottom='medium'>
									<Text weight='medium' size='small'>
										Discounts
									</Text>
								</Box>
								<Stack space='medium' dividers>
									{currentWeb.coupons.map(({ coupon_id }) => {
										return (
											<Box key={coupon_id}>
												<Coupon couponId={coupon_id}></Coupon>
											</Box>
										);
									})}
								</Stack>
							</Box>
						</Card.Section>
					)}
				</Stack>
			</Card>
		</Stack>
	);
};

export default connect(
	(state) => ({
		currentWeb: getCurrentWeb(state),
		requesting: requestingCurrentWeb(state),
	}),
	{
		requestCurrentWeb: requestCurrentWebIfNotRequested,
	},
)(CurrentWebPlanCard);
